import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { fmDataContext } from "../../Context/FmData";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import LoadingCircle from "../LoadingCircle/LoadingCircle";
import { fmTfReleasesContext } from "../../Context/TfReleasesContext";
import userCan from "../../helpers/userCan";
import "swiper/css";
import "swiper/css/pagination";
import Swal from "sweetalert2/dist/sweetalert2.all.min";
import "@sweetalert2/theme-dark/dark.min.css";
import jwtDecode from "jwt-decode";
import { authenticationContext } from "../../Context/AuthContext";
import ReleaseCard from "../ReleaseCard/ReleaseCard";

const TfReleaseDetails = () => {
  let [mounted, setMounted] = useState(false);

  let { tfReleaseId } = useParams();

  let { baseUrl, navigate, showData, editItemExistence, globalCrumbs, setGlobalCrumbs } = useContext(fmDataContext);
  let { user } = useContext(authenticationContext);

  let [currentTfRelease, setCurrentTfRelease] = useState({});

  let [isCurrentTfReleaseLoading, setIsCurrentTfReleaseLoading] = useState(true);

  let [isForceDeleteLoading, setIsForceDeleteLoading] = useState(false);

  let { setTfReleaseMsg } = useContext(fmTfReleasesContext);

  let userToken = jwtDecode(localStorage.getItem("userToken")).accessToken;

  const removeTfRelease = (reqMethod, pathName, headers, setLoading) => {
    Swal.fire({
      title: "Are you sure?",
      html: `<p class="mb-0">You will remove <span class="fu-text-light-gray">${currentTfRelease.data.additional_release_title ? currentTfRelease.data.additional_release_title : currentTfRelease.data.release_data.release_title}</span> </p><p class="mb-0">from top five releases list!</p>`,
      icon: "warning",
      showCancelButton: true,
      customClass: {
        cancelButton: "popup-btn",
        confirmButton: "popup-btn",
      },
      confirmButtonText: "Yes, remove!",
    }).then((result) => {
      if (result.isConfirmed) {
        if (userCan("fm_top_five_releases_force_delete")) {
          editItemExistence(reqMethod, pathName, headers, setLoading)
            .then((response) => {
              setTfReleaseMsg(`${currentTfRelease.data.additional_release_title ? currentTfRelease.data.additional_release_title : currentTfRelease.data.release_data.release_title} Removed Successfully`);
              navigate("/fm-top-five-releases");
            })
            .catch((error) => {
              navigate("/not-found");
            });
        } else {
          navigate("/not-found");
        }
      }
    });
  };

  const getTfRelease = (reqMethod, pathName, setLoading = setIsCurrentTfReleaseLoading, headers) => {
    showData(reqMethod, pathName, setLoading, headers)
      .then((response) => {
        if (response.data.data.release_data !== null) {
          if (response.data.data.release_data.release_image.includes("via.placeholder.com")) {
            response.data.data.release_data.release_image = response.data.data.release_data.release_image.replace("http://127.0.0.1:8000/storage/", "");
          }
        }

        setCurrentTfRelease(response.data);
        setLoading(false);
      })
      .catch((error) => {
        navigate("/not-found");
      });
  };

  useEffect(() => {
    getTfRelease("GET", `${baseUrl}fm-one-from-top-five-releases/${tfReleaseId}`, setIsCurrentTfReleaseLoading, {
      Accept: "application/json",
      "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
      Authorization: `Bearer ${userToken}`,
    });
    setMounted(true);
  }, []);

  useEffect(() => {
    getTfRelease("GET", `${baseUrl}fm-one-from-top-five-releases/${tfReleaseId}`, setIsCurrentTfReleaseLoading, {
      Accept: "application/json",
      "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
      Authorization: `Bearer ${userToken}`,
    });
    setMounted(true);
  }, [tfReleaseId]);

  useEffect(() => {
    if (mounted && currentTfRelease.data) {
      let globalCrumbsUpdated = globalCrumbs.map((crumb) => {
        if (crumb.name === tfReleaseId.toUpperCase()) {
          crumb.name = currentTfRelease.data.additional_release_title ? currentTfRelease.data.additional_release_title.toUpperCase() : currentTfRelease.data.release_data.release_title.toUpperCase();
        }
        return crumb;
      });
      setGlobalCrumbs(globalCrumbsUpdated);
    }
  }, [currentTfRelease]);

  return (
    <>
      {!isCurrentTfReleaseLoading ? (
        <>
          <div className="min-vh-100">
            <div className="container">
              <div className="d-flex align-items-center mb-2 mb-sm-3 mt-3">
                {(currentTfRelease.data.release_data.is_pre_order || currentTfRelease.data.release_data.is_from_top_five) && (
                  <div className="d-inline-flex align-items-center">
                    {currentTfRelease.data.release_data.is_pre_order && (
                      <div className="pre-order-circle me-2" data-title="out soon">
                        <i className="bi bi-hourglass-split d-inline-flex"></i>
                      </div>
                    )}
                  </div>
                )}
                <h1 className="fu-text-3-rem page-heading-title-sm-2-rem fu-fw-800 fu-text-white">{currentTfRelease.data.additional_release_title ? currentTfRelease.data.additional_release_title : currentTfRelease.data.release_data.release_title}</h1>
              </div>

              <div className="py-0 py-sm-2 mt-2 mt-sm-3">
                <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-4">
                  {userCan("fm_top_five_releases_update") ? (
                    <div className="mx-2 my-1 my-sm-0">
                      <Link to={`/fm-top-five-releases/update/${currentTfRelease.data.key}`} className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading ? "disabled" : ""}`} disabled={isForceDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Edit
                      </Link>
                    </div>
                  ) : (
                    ""
                  )}

                  {userCan("fm_top_five_releases_force_delete") ? (
                    <div className="ms-2 my-1 my-sm-0">
                      <button
                        className={`btn fu-btn-sm fu-btn-gray ${isForceDeleteLoading ? "disabled" : ""}`}
                        onClick={() =>
                          removeTfRelease(
                            "DELETE",
                            `${baseUrl}fm-top-five-releases/delete/${currentTfRelease.data.key}`,
                            {
                              Accept: "application/json",
                              "fm-api-secret-key": process.env.REACT_APP_FM_API_SECRET_KEY,
                              Authorization: `Bearer ${user.accessToken}`,
                            },
                            setIsForceDeleteLoading
                          )
                        }
                        disabled={isForceDeleteLoading ? true : false}>
                        <span className="btn-bg"></span>
                        Remove
                      </button>
                    </div>
                  ) : (
                    ""
                  )}

                  {isForceDeleteLoading ? (
                    <div className="position-relative ms-4">
                      <LoadingCircle circleCont={35} icon={30} loader={35} dot={35} />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="tf-releases-tags">
                  <div className="mb-4 info-tags-container justify-content-start">
                    {currentTfRelease.data._id ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#ID: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data._id}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.key ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">#KEY: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.key}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.release_order ? (
                      <>
                        <div className="mx-1 my-1 info-tag">
                          <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">ORDER IN TOP 5: </span>
                          <span className="d-inline-flex justify-content-center align-items-center">#{currentTfRelease.data.release_order}</span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    {currentTfRelease.data.created_at ? (
                      userCan("created_at_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED AT: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentTfRelease.data.created_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.updated_at ? (
                      userCan("updated_at_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED AT: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{new Date(currentTfRelease.data.updated_at).toLocaleString("en-US", { timeZone: "Africa/Cairo", hour12: true })}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}

                    {currentTfRelease.data.created_by ? (
                      userCan("created_by_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, NAME: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.created_by.name}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.created_by ? (
                      userCan("created_by_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, #ID: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.created_by._id}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.created_by ? (
                      userCan("created_by_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">CREATED BY, KEY: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.created_by.key}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.updated_by ? (
                      userCan("updated_by_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, NAME: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.updated_by.name}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.updated_by ? (
                      userCan("updated_by_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, #ID: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.updated_by._id}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    {currentTfRelease.data.updated_by ? (
                      userCan("updated_by_show") ? (
                        <>
                          <div className="mx-1 my-1 info-tag">
                            <span className="d-inline-flex justify-content-center align-items-center me-2 fu-text-yellow">UPDATED BY, KEY: </span>
                            <span className="d-inline-flex justify-content-center align-items-center">{currentTfRelease.data.updated_by.key}</span>
                          </div>
                        </>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                {/* Release */}
                {currentTfRelease.data.release_data !== null ? (
                  <div className="mb-4">
                    <div className="d-flex align-items-center mb-4">
                      <div className="flex-grow-1 iu-row-heading">
                        <h2 className="mb-0 row-title">Release</h2>
                      </div>
                    </div>
                    <div className="row gx-3">
                      <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3">
                        <ReleaseCard release={currentTfRelease.data.release_data} />
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <LoadingScreen />
      )}
    </>
  );
};

export default TfReleaseDetails;
